import axiosHttp from "services/axiosHttp";
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const fetchPettyCashMyFloatList = createAsyncThunk("fetchPettyCashMyFloatList", async (_, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get("petty-cash/my-floats");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PettyCashMyFloatListSlice = createSlice({
	name: "PettyCashMyFloatListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashMyFloatListState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashMyFloatList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});

		builder.addCase(fetchPettyCashMyFloatList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashMyFloatList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload || action.error;
		});
	},
});

export const { resetPettyCashMyFloatListState } = PettyCashMyFloatListSlice.actions;
export default PettyCashMyFloatListSlice.reducer;
